import {Component} from '@angular/core';
import {NgbToast} from '@ng-bootstrap/ng-bootstrap';
import {ToastService} from './toast-service';

@Component({
  selector: 'app-toasts',
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
  host: {'class': 'toast-wrapper', 'style': 'z-index: 11000'},
  imports: [NgbToast],
})
export class ToastsContainer {
  constructor(public toastService: ToastService) {
  }
}
